/**
 * File download and URL handling utilities
 */

/**
 * Format base URL
 * @param {string} url - Original URL
 * @returns {string} - Formatted URL
 */
export function formatBaseUrl(url) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https://' + url;
  }
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

/**
 * Validate if URL is valid
 * @param {string} string - String to validate
 * @returns {boolean} - Whether it's a valid URL
 */
export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
}

/**
 * Download file
 * @param {string} content - File content
 * @param {string} filename - Filename
 * @param {string} contentType - MIME type
 */
export function downloadFile(content, filename, contentType) {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
